<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer">
    <h3 slot="header" class="mb-0">Angkasa Report</h3>
    <!-- SAS App Section -->
    <div v-if="_gAuth.isAppSas()">
      <div v-if="tableData.length > 0" class="rounded-bottom">
        <el-table
          :data="tableData"
          show-summary
          :summary-method="getTotal"
          sum-text="Total"
          style="width: 100%"
        >
          <el-table-column
            label="Organization/Type"
            min-width="220"
            width="auto"
          >
            <template slot-scope="scope">
              <p class="top-line text-break">
                {{ scope.row.aks_rep_itm_org_name }}
              </p>
              <p
                v-for="(detail, index) in scope.row.aks_rep_itm_details"
                :key="index"
                class="text-capitalize bottom-line text-break mb-0"
              >
                {{ detail.aks_rep_itm_detail_type }}
              </p>
            </template>
          </el-table-column>

          <el-table-column
            prop="aks_rep_itm_org_no"
            label="Code"
            min-width="120"
            width="auto"
          >
            <template slot-scope="scope">
              <p class="top-line">{{ scope.row.aks_rep_itm_org_no }}</p>
            </template>
          </el-table-column>

          <el-table-column
            label="Acc. Type/Begin-End"
            min-width="220"
            width="auto"
          >
            <template slot-scope="scope">
              <p class="top-line text-break">
                {{ scope.row.aks_rep_itm_org_status }}
              </p>
              <p
                v-for="(detail, index) in scope.row.aks_rep_itm_details"
                :key="index"
                class="text-capitalize bottom-line mb-0"
              >
                {{ detail.aks_rep_itm_detail_begin }} -
                {{ detail.aks_rep_itm_detail_end }}<br />
              </p>
            </template>
          </el-table-column>

          <el-table-column label="Total Amt./Deduction Amt. (RM)" width="160">
            <template slot-scope="scope">
              <p class="top-line text-break">
                {{
                  scope.row.aks_rep_itm_org_deduction_amount | moneyFormatter
                }}
              </p>
              <p
                v-for="(detail, index) in scope.row.aks_rep_itm_details"
                :key="index"
                class="text-capitalize bottom-line mb-0"
              >
                {{ detail.aks_rep_itm_detail_deduction_amount | moneyFormatter
                }}<br />
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-else class="bg-light p-3 text-center rounded-bottom">
        <p class="text-xs">No Angkasa Report recorded</p>
      </div>
    </div>

    <!-- NON-SAS Section -->
    <div v-else>
      <!-- INFORMATION TABLE (NEW) - Conditionally Display -->
      <div v-if="hasInformationData">
        <h5 class="mb-3">SISTEM POTONGAN GAJI ANGKASA (SPGA) INFORMATION</h5>
        <div class="information-table-wrapper mb-4">
          <el-table
            :data="formattedInformation"
            style="width: 100%"
            class="non-sas-table information-table"
            :show-header="false"
            empty-text="No Information Available"
          >
            <el-table-column prop="label" width="200" class-name="info-label">
              <template slot-scope="scope">
                <strong>{{ scope.row.label }}</strong>
              </template>
            </el-table-column>
            <el-table-column prop="value" class-name="info-value">
              <template slot-scope="scope">
                {{ scope.row.value }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <h5 class="mb-3">ANGKASA MONTHLY DEDUCTION</h5>

      <div v-if="hasAngkasaData" class="rounded-bottom">
        <div class="angkasa-note">
          <small>
            <strong>Note:</strong> The following information is provided by
            third party sources for your reference. Angkasa does not guarantee
            the accuracy of the information. Please check with the Creditors for
            confirmation. Users should NOT treat the information as conclusive
            factor for evaluation purpose.
          </small>
        </div>

        <el-table
          :data="monthlyDeductions"
          show-summary
          :summary-method="getMonthlyTotal"
          sum-text="Total Deduction"
          style="width: 100%"
          class="mb-4 non-sas-table"
          :span-method="objectSpanMethod"
        >
          <el-table-column label="No." width="60" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isMainRow">{{
                getRowNumber(scope.$index)
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Organization" min-width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isMainRow">{{ scope.row.org_name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Code" width="80" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isMainRow">{{ scope.row.org_no }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Type" min-width="200" align="center">
            <template slot-scope="scope">{{ scope.row.type }}</template>
          </el-table-column>

          <el-table-column label="Account Status" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isMainRow">{{ scope.row.org_status }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Begin" width="80" align="center">
            <template slot-scope="scope">{{ scope.row.begin }}</template>
          </el-table-column>

          <el-table-column label="End" width="80" align="center">
            <template slot-scope="scope">{{ scope.row.end }}</template>
          </el-table-column>

          <el-table-column
            label="Deduction Amount (RM)"
            width="140"
            align="center"
          >
            <template slot-scope="scope">{{
              formatMoney(scope.row.deduction_amount)
            }}</template>
          </el-table-column>

          <el-table-column label="Total Amount (RM)" width="140" align="center">
            <template slot-scope="scope">
              <strong v-if="scope.row.isMainRow">
                {{ formatMoney(scope.row.org_deduction_amount) }}
              </strong>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-else class="bg-light p-3 text-center rounded mb-4">
        <p class="text-muted mb-0">No Information Available</p>
      </div>

      <!-- PENDING DEDUCTION SECTION -->
      <h5 class="mb-3">ANGKASA PENDING DEDUCTION</h5>
      <div v-if="hasPendingDeductions" class="rounded-bottom">
        <el-table
          :data="pendingDeductions"
          style="width: 100%"
          class="mb-4 non-sas-table"
          :summary-method="getPendingTotal"
          show-summary
          sum-text="TOTAL PENDING DEDUCTION:"
        >
          <el-table-column label="No." width="60" align="center" type="index">
          </el-table-column>

          <el-table-column label="Organization" min-width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.organization }}
            </template>
          </el-table-column>

          <el-table-column label="Code" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.row.code }}
            </template>
          </el-table-column>

          <el-table-column label="Account Status" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.accountStatus }}
            </template>
          </el-table-column>

          <el-table-column label="Start Date" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.row.startDate }}
            </template>
          </el-table-column>

          <el-table-column
            label="Deduction Amount (RM)"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatMoney(scope.row.deductionAmount) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-else class="bg-light p-3 text-center rounded mb-4">
        <p class="text-muted mb-0">No Information Available</p>
      </div>

      <!-- PAYMENT HISTORY SECTION -->
      <h5 class="mb-3">ANGKASA PAYMENT HISTORY</h5>
      <div v-if="hasPaymentHistory">
        <el-table
          :data="formattedPaymentHistory"
          style="width: 100%"
          border
          class="payment-history-table non-sas-table"
        >
          <!-- Code Column -->
          <el-table-column label="Code" width="100" align="center" fixed>
            <template slot-scope="scope">
              <div class="code-cell">{{ scope.row.code }}</div>
            </template>
          </el-table-column>

          <!-- Deduction Month Column -->
          <el-table-column
            label="Deduction Month"
            align="center"
            width="140"
            fixed
          >
            <template slot-scope="scope">
              <div class="deduction-month-cell">
                <div class="sub-header">Date Process</div>
                <div class="sub-header">Amount</div>
              </div>
            </template>
          </el-table-column>

          <!-- Dynamic Month Columns -->
          <el-table-column
            v-for="(month, monthIndex) in paymentMonths"
            :key="month"
            :label="month"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <div
                class="month-data-split"
                :class="{
                  'highlight-zero-cell':
                    scope.row.amounts[monthIndex] === '-' ||
                    scope.row.amounts[monthIndex] === '0.00' ||
                    parseFloat(scope.row.amounts[monthIndex]) === 0,
                }"
              >
                <!-- Date Process Row -->
                <div class="data-row date-process">
                  {{
                    scope.row.dates[monthIndex] &&
                    scope.row.dates[monthIndex] !== "-"
                      ? scope.row.dates[monthIndex]
                      : "—"
                  }}
                </div>
                <!-- Amount Row -->
                 <div
                  class="data-row amount"
                  :class="{
                    'text-success':
                      parseFloat(scope.row.amounts[monthIndex]) > 0,
                    'text-danger':
                      parseFloat(scope.row.amounts[monthIndex]) < 0,
                  }"
                >
                  {{ formatMoney(scope.row.amounts[monthIndex]) }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-else class="bg-light p-3 text-center rounded">
        <p class="text-muted mb-0">No Information Available</p>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "AngkasaReportModal",
  props: {
    angkasaReport: Array,
    angkasaReportResp: Object,
    show_angkasa_full_view: Boolean,
  },
  components: { Modal, [Table.name]: Table, [TableColumn.name]: TableColumn },
  data() {
    return {
      tableData: [],
      total: "",
      spanArr: [],
      pos: 0,
    };
  },
  computed: {
    show: {
      get() {
        return this.show_angkasa_full_view;
      },
      set(value) {
        this.$emit("update:show_angkasa_full_view", value);
      },
    },
    // Information data from JSON response
    informationData() {
      const info = this.angkasaReportResp?.information || {};
      return {
        matched_name: info.matched_name || "-",
        matched_new_ic: info.matched_new_ic || "-",
        matched_old_ic: info.matched_old_ic || "-",
        status: info.status || "-",
        remark: info.remark || "-",
        reference_no: info.reference_no || "-",
        salary_no: info.salary_no || "-",
      };
    },
    // Check if there's valid information data (not just default values)
    hasInformationData() {
      const info = this.informationData;
      // Check if any field has actual data (not just the default "-" values)
      return Object.values(info).some(value => 
        value && value !== "-" && value !== ""
      );
    },
    // Format information for table display
    formattedInformation() {
      const info = this.informationData;
      return [
        { label: "Matched Name", value: info.matched_name },
        { label: "Matched New IC No", value: info.matched_new_ic },
        { label: "Matched Old IC No", value: info.matched_old_ic },
        { label: "Status", value: info.status },
        { label: "Remarks", value: info.remark },
        { label: "Account ID / Reference", value: info.reference_no },
        { label: "Salary No", value: info.salary_no },
      ];
    },

    hasAngkasaData() {
      const d = this.angkasaReportResp?.monthly_deductions?.monthly_items;
      return Array.isArray(d) && d.length > 0;
    },
    // Dynamic pending deductions from JSON response
    hasPendingDeductions() {
      return this.pendingDeductions && this.pendingDeductions.length > 0;
    },
    pendingDeductions() {
      if (!this.angkasaReportResp?.monthly_deductions?.monthly_items) return [];

      const pendingItems = [];

      this.angkasaReportResp.monthly_deductions.monthly_items.forEach((org) => {
        if (org.detail && Array.isArray(org.detail)) {
          org.detail.forEach((detail) => {
            // Check if this is a pending deduction (future start date or specific status)
            const startDate = detail.begin;
            const currentDate = new Date();
            const currentYearMonth = `${currentDate.getFullYear()}/${String(
              currentDate.getMonth() + 1
            ).padStart(2, "0")}`;

            // If start date is in the future or has specific pending indicators
            if (
              this.isFutureDate(startDate, currentYearMonth) ||
              detail.type?.includes("DALAM PROSES")
            ) {
              pendingItems.push({
                organization: org.org_name || "",
                code: org.org_no,
                accountStatus: "DALAM PROSES",
                startDate: detail.begin,
                deductionAmount: parseFloat(detail.deduction_amount) || 0,
              });
            }
          });
        }
      });

      return pendingItems;
    },
    totalPendingDeduction() {
      if (!this.hasPendingDeductions) return "0.00";
      const total = this.pendingDeductions.reduce((sum, item) => {
        return sum + Math.abs(parseFloat(item.deductionAmount));
      }, 0);
      return total.toFixed(2);
    },
    monthlyDeductions() {
      if (!this.hasAngkasaData) return [];
      const rows = [];
      this.angkasaReportResp.monthly_deductions.monthly_items.forEach(
        (item) => {
          // Check if there are details
          if (item.detail && item.detail.length > 0) {
            // Main row: Populate with org data and the FIRST detail's data
            rows.push({
              isMainRow: true,
              org_name: item.org_name,
              org_no: item.org_no,
              org_status: item.org_status,
              org_deduction_amount: item.org_deduction_amount,
              type: item.detail[0].type, // Use first detail's type
              begin: item.detail[0].begin, // Use first detail's begin
              end: item.detail[0].end, // Use first detail's end
              deduction_amount: item.detail[0].deduction_amount, // Use first detail's amount
            });
            // Sub-rows: Start from the SECOND detail (if any)
            for (let i = 1; i < item.detail.length; i++) {
              const detail = item.detail[i];
              rows.push({
                isMainRow: false,
                org_name: "",
                org_no: "",
                org_status: "",
                org_deduction_amount: "",
                type: detail.type,
                begin: detail.begin,
                end: detail.end,
                deduction_amount: detail.deduction_amount,
              });
            }
          } else {
            // If no details, still add the main row (but it will have empty type/begin/end/deduction, which is rare)
            rows.push({
              isMainRow: true,
              org_name: item.org_name,
              org_no: item.org_no,
              org_status: item.org_status,
              org_deduction_amount: item.org_deduction_amount,
              type: "",
              begin: "",
              end: "",
              deduction_amount: "",
            });
          }
        }
      );
      return rows;
    },
    totalDeduction() {
      return (
        this.angkasaReportResp?.monthly_deductions?.total_deduction || "0.00"
      );
    },
    hasPaymentHistory() {
      return (
        this.angkasaReportResp?.original_payment_history?.payment_detail?.item
          ?.length > 0
      );
    },
    paymentMonths() {
      return (
        this.angkasaReportResp?.original_payment_history?.payment_month?.item ||
        []
      );
    },
    formattedPaymentHistory() {
      if (!this.hasPaymentHistory) return [];
      return this.angkasaReportResp.original_payment_history.payment_detail.item.map(
        (org) => ({
          code: org.code,
          dates: org.process_date.item,
          amounts: org.amount.item,
        })
      );
    },
  },
  watch: {
    angkasaReport: {
      immediate: true,
      handler(val) {
        if (val.length > 0) {
          this.tableData = val[0].aks_rep_items;
          this.total = val[0].aks_rep_total_deduction;
        } else {
          this.tableData = [];
          this.total = 0;
        }
      },
    },
  },
  methods: {
      formatMoney(value) {
      const num = parseFloat(value);
      if (isNaN(num)) return "0.00";
      return num.toLocaleString("en-MY", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    // Helper method to check if a date is in the future
    isFutureDate(dateString, currentYearMonth) {
      if (!dateString) return false;

      const [month, year] = dateString.split("/");
      const date = new Date(parseInt(year), parseInt(month) - 1);
      const [currentYear, currentMonth] = currentYearMonth.split("/");
      const current = new Date(
        parseInt(currentYear),
        parseInt(currentMonth) - 1
      );

      return date > current;
    },
    // Add method for pending deductions total
    getPendingTotal({ columns }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === columns.length - 1)
          sums[index] = this.formatMoney(this.totalPendingDeduction);
        else if (index === columns.length - 2)
          sums[index] = "TOTAL PENDING DEDUCTION:";
        else sums[index] = "";
      });
      return sums;
    },
    formatAmount(value) {
      if (!value || value === "-") return "0.00";
      const num = parseFloat(value);
      if (isNaN(num)) return "0.00";
      return num.toLocaleString("en-MY", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getRowNumber(index) {
      let count = 1;
      for (let i = 0; i < index; i++) {
        if (this.monthlyDeductions[i]?.isMainRow) count++;
      }
      return count;
    },
    objectSpanMethod({ row, columnIndex, rowIndex }) {
      if ([0, 1, 2, 4, 8].includes(columnIndex)) {
        if (row.isMainRow) {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.monthlyDeductions.length; i++) {
            if (this.monthlyDeductions[i].isMainRow) break;
            rowspan++;
          }
          return { rowspan, colspan: 1 };
        } else return { rowspan: 0, colspan: 0 };
      }
    },
    getMonthlyTotal({ columns }) {
      const sums = [];
      columns.forEach((_, i) => {
        if (i === columns.length - 2) sums[i] = "Total Deduction:";
        else if (i === columns.length - 1)
          sums[i] = this.formatMoney(this.totalDeduction);
        else sums[i] = "";
      });
      return sums;
    },
    getTotal() {
      const sums = [];
      sums[2] = "Total";
      // ✅ UPDATED
      sums[3] = this.formatMoney(this.total);
      return sums;
    },
  },
};
</script>

<style scoped>
::v-deep .non-sas-table.el-table {
  border: 2px solid #000;
  color: #000;
}

/* Enhanced Header Styles - Matching the image */
::v-deep .non-sas-table .el-table__header {
  background: #808080 !important;
}

::v-deep .non-sas-table .el-table__header th {
  background:  #252938 !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  border: none !important;
  text-transform: none !important;
  text-align: center !important;
  vertical-align: middle;
  padding: 8px 0;
}

::v-deep .non-sas-table .el-table__header th .cell {
  text-transform: none !important;
  font-weight: 400 !important;
  color: #fff !important;
  font-size: 14px !important;
  font-family: Arial, sans-serif;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  white-space: normal;
  word-break: break-word;
}

/* Additional styling for better header appearance */
::v-deep .non-sas-table .el-table__header-wrapper {
  background: #252938  !important;
}

/* Make sure header cells have consistent height */
::v-deep .non-sas-table .el-table__header th {
  height: 45px;
}

::v-deep .non-sas-table .el-table__body td {
  background: #fff !important;
  border: 1px solid #000 !important;
  color: #000 !important;
}

/* Summary Row (Footer) Styling with Borders */
::v-deep .non-sas-table .el-table__footer-wrapper td {
  border: 1px solid #000 !important;
  background-color: #fff !important;
  color: #000 !important;
  font-weight: bold;
  padding: 8px 0 !important;
  text-align: center;
}

::v-deep .non-sas-table .el-table__footer-wrapper .cell {
  color: #000 !important;
  font-weight: bold;
}

/* Ensure summary row text is black and properly aligned */
::v-deep .non-sas-table .el-table__footer .cell {
  font-weight: bold;
  color: #000 !important;
}

.angkasa-note {
  font-style: italic;
  margin: 10px 0;
  padding: 10px;
  background: #c1bfb4;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.3;
  color: #000;
}

/* Payment History Styles */
.deduction-month-cell {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.sub-header {
  padding: 4px 2px;
  font-weight: bold;
  border-bottom: 1px solid #000;
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sub-header:last-child {
  border-bottom: none;
}

.month-data-split {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.data-row {
  padding: 4px 2px;
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #000;
}

.data-row:last-child {
  border-bottom: none;
}

.date-process {
  border-bottom: 1px solid #000;
}

.amount {
  font-weight: bold;
}

.code-cell {
  font-weight: bold;
  color: #000;
}

/* Ensure all text is black */
::v-deep .non-sas-table * {
  color: #000 !important;
}

::v-deep .payment-history-table .el-table__header-wrapper {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #808080;
}

/* Highlight entire cell for zero or dash amounts */
::v-deep
  .payment-history-table
  .el-table__body
  td
  .month-data-split.highlight-zero-cell {
  background-color: #ffebee !important;
}

::v-deep
  .payment-history-table
  .el-table__body
  td
  .highlight-zero-cell
  .data-row {
  background-color: transparent !important;
}
/* 💡 UPDATED: More specific styling for information table rows */
::v-deep .information-table.non-sas-table .el-table__body td {
  border: 1px solid #000 !important;
  background-color: #fff !important;
  padding: 6px 10px !important;
  color: #000 !important;
}

::v-deep .information-table.non-sas-table .el-table__body td.info-label {
  text-align: center !important; 
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #808080 !important;
}

::v-deep .information-table.non-sas-table .el-table__body td.info-value {
  text-align: left !important;
  padding-left: 20px !important; /* Add left padding for data */
}

::v-deep .information-table.non-sas-table .info-label .cell {
  /* font-weight: bold; */
  width: 200px !important;
  text-align: center !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .information-table.non-sas-table .info-value .cell {
  text-align: left !important;
  padding-left: 20px !important;
}
</style>